import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Inline renderer: converts a string with **bold** and [[Label|target]] tokens
 * into an array of React nodes (text + <strong> + <Link> chips).
 *
 * `target` syntax:
 *   - `slug`            → /calculator/{slug}
 *   - `state:foo`       → /calculators/state-income-tax/foo
 *   - `/path`           → used as-is (e.g. `/states`, `/blog/some-post`)
 *
 * Used in:
 *   - ResultExplainer (calculator key takeaways / next steps)
 *   - BlogPostPage    (inline paragraph mentions of calculators)
 *
 * Safe because all source strings are author-controlled in our codebase.
 */
export const renderInline = (input) => {
  if (typeof input !== "string") return input;
  const parts = [];
  const regex = /\[\[([^\]|]+)\|([^\]]+)\]\]|\*\*([^*]+)\*\*/g;
  let lastIdx = 0;
  let m;
  let key = 0;
  while ((m = regex.exec(input)) !== null) {
    if (m.index > lastIdx) parts.push(input.slice(lastIdx, m.index));
    if (m[1] !== undefined) {
      const label = m[1];
      const target = m[2];
      let to;
      if (target.startsWith("/")) to = target;
      else if (target.startsWith("state:")) to = `/calculators/state-income-tax/${target.slice(6)}`;
      else to = `/calculator/${target}`;
      parts.push(
        <Link
          key={`k${key++}`}
          to={to}
          data-testid={`calc-link-${target}`}
          className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.15em] bg-foreground text-background px-2.5 py-1 mx-0.5 border-2 border-foreground hover:bg-primary hover:border-primary transition-colors whitespace-nowrap align-middle"
        >
          {label}
          <ArrowUpRight className="w-3 h-3" />
        </Link>,
      );
    } else {
      parts.push(<strong key={`k${key++}`}>{m[3]}</strong>);
    }
    lastIdx = regex.lastIndex;
  }
  if (lastIdx < input.length) parts.push(input.slice(lastIdx));
  return parts;
};
